export default __webpack_public_path__ + "static/media/logo_black.56897491.png";